export const TagActions = {
    TAG: 'tag',
    UNTAG: 'untag',
};
